import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import LocizeBackend from "i18next-locize-backend";
import Configuration from "./configuration";

const isDev = Configuration.environment !== "production";

const initOptions = {
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    supportedLngs: ["en", "cs", "de", "id", "it", "nn"],
    cleanCode: true,
    backend: {
        projectId: "758c5008-9e35-428f-9127-fbc92aafc070", // Experience Engine project
        apiKey: isDev ? Configuration.localizationApiKey : undefined, // We allow api key usage in dev for testing and bug discovery.
        referenceLng: "en",
        version: isDev ? "latest" : "live",
    },
};

/**
 * We use locize 'a SaaS platform' to manage localization of our app. We configure
 * the connection here and plug any required logic into i18next to handle this.
 */
i18n.use(initReactI18next).use(LocizeBackend).use(LanguageDetector).init(initOptions, undefined);

export default i18n;
